module.exports = __webpack_public_path__ + "static/media/NUEL.9ea3e64a.png";